import { Course, ExpireAction, GetCourseDetailsByIdPublicQuery, Maybe } from "../../generated/graphql"
import { isDefined } from "../../helpers/typeScriptHelpers"

export const evaluateTimeRestrictions = ({
    startDateTime,
    endDateTime,
    expireAction,
}: {
    startDateTime?: string
    endDateTime?: string
    expireAction?: Maybe<ExpireAction> | undefined
}) => {
    const currentTime = new Date()
    const startDate = startDateTime ? new Date(startDateTime) : null
    const endDate = endDateTime ? new Date(endDateTime) : null

    if (startDate && endDate) {
        // console.log("Both start and end date")
        return currentTime >= startDate && currentTime <= endDate /* || expireAction === ExpireAction.ShowToAll */
    } else if (startDate) {
        // console.log("Only start date")
        return currentTime >= startDate
    } else if (endDate) {
        // console.log("Only end date")
        return currentTime <= endDate /* || expireAction === ExpireAction.ShowToAll */
    }

    // console.log("No date")

    return true
}

type BookingRestrictionInput = GetCourseDetailsByIdPublicQuery["courseByIdPublic"]["bookingRestriction"]
export type RestrictionsType = {
    membersOnly: boolean
    prerequisites: boolean
    prerequisiteCourses: Array<Course> | undefined
    isInTimeRange: boolean
}

export const getBookingRestrictions = (bookingRestrictions: BookingRestrictionInput) => {
    const { active, startDateTime, endDateTime, expireAction, prerequisiteCourses, membersOnly } = bookingRestrictions || {}

    // Ohne Zeitfenster entscheidet allein der Schalter `active` (wie deriveBookingRestrictionActive im Backend).
    const switchedOff = active === false && !startDateTime && !endDateTime
    const inTimeRange = !switchedOff && evaluateTimeRestrictions({ startDateTime, endDateTime, expireAction })

    let result = {
        membersOnly: false,
        prerequisites: false,
        prerequisiteCourses: undefined as Array<Course> | undefined,
        isInTimeRange: inTimeRange,
    }

    if (inTimeRange && prerequisiteCourses && prerequisiteCourses.length > 0 && membersOnly) {
        // console.log("Members only and prerequisites")
        result.membersOnly = true
        result.prerequisites = true
        result.prerequisiteCourses = prerequisiteCourses as Array<Course>
    } else if (inTimeRange && prerequisiteCourses && prerequisiteCourses.length > 0 && !membersOnly) {
        // console.log("Prerequisites only")
        result.prerequisites = true
        result.prerequisiteCourses = prerequisiteCourses as Array<Course>
    } else if (inTimeRange && membersOnly) {
        // console.log("Members only")
        result.membersOnly = true
    } else {
        // console.log("No restrictions")
    }

    return result
}

export const definedInputValue = <T>(value: Maybe<T> | undefined): T | undefined => {
    return isDefined(value) ? value : undefined
}
